module.exports = __webpack_public_path__ + "img/socket.b17488bb.svg";